import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-15 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = {
  key: 0,
  class: "list-item pt-5 pb-5 pt-md-20 pb-md-5 ps-20 pe-5 position-relative d-sm-flex justify-content-between align-items-center bg-ecf3f2"
}
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "d-block text-black fw-semibold fs-md-15 mb-1" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "card mb-25 border-0 pt-2 rounded-2 welcome-lms-courses-box" }
const _hoisted_12 = { class: "card-body pe-15 ps-15 letter-spacing" }
const _hoisted_13 = { class: "row align-items-center p-0" }
const _hoisted_14 = { class: "content p-0" }
const _hoisted_15 = { class: "table" }
const _hoisted_16 = { class: "fw-bold text-white fs-6" }
const _hoisted_17 = { class: "fw-bold text-white fs-6" }
const _hoisted_18 = { class: "fw-bold text-white fs-6" }
const _hoisted_19 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_20 = { class: "card mb-25 border-0 pt-0 rounded-2 welcome-lms-courses-box2" }
const _hoisted_21 = { class: "card-body pe-15 ps-15 letter-spacing" }
const _hoisted_22 = { class: "row align-items-center p-0" }
const _hoisted_23 = { class: "content p-0" }
const _hoisted_24 = { class: "table" }
const _hoisted_25 = { class: "fw-bold text-white fs-6" }
const _hoisted_26 = { class: "fw-bold text-white fs-6" }
const _hoisted_27 = { class: "fw-bold text-white fs-6" }
const _hoisted_28 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_29 = { class: "card mb-25 border-0 pt-2 rounded-2 welcome-lms-courses-box" }
const _hoisted_30 = { class: "card-body pe-15 ps-15 letter-spacing" }
const _hoisted_31 = { class: "row align-items-center p-0" }
const _hoisted_32 = { class: "content p-0" }
const _hoisted_33 = {
  class: "table",
  style: {"background-color":"none !important"}
}
const _hoisted_34 = { class: "fw-bold text-white fs-6" }
const _hoisted_35 = { class: "fw-bold text-white fs-6" }
const _hoisted_36 = { class: "fw-bold text-white fs-6" }
const _hoisted_37 = { class: "card mb-25 border-0 rounded-0 bg-white recent-activity-box" }
const _hoisted_38 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_39 = { class: "list ps-0 mb-0 list-unstyled" }
const _hoisted_40 = { class: "text-black fw-bold" }
const _hoisted_41 = { class: "fs-md-15 text-paragraph lh-base mb-0 fw-normal mt-5" }
const _hoisted_42 = { class: "d-block fs-13 mt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Adresse Postale"),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "abonnement",
                modelValue: _ctx.abonnementSelected,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.abonnementSelected) = $event))
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps({
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                  }, field, {
                    placeholder: "Renseigner l'adresse postale ici",
                    "filter-results": false,
                    "min-chars": 3,
                    "resolve-on-load": false,
                    delay: 0,
                    searchable: true,
                    "options-limit": 300,
                    "no-options-text": _ctx.noOptionsTextAbb,
                    options: async (query) => { return await _ctx.fetchAbonnements(query) },
                    noResultText: "Aucun enregistrement trouvé"
                  }), null, 16, ["modelValue", "onUpdate:modelValue", "no-options-text", "options"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "abonnement",
                class: "text-danger"
              })
            ])
          ]),
          (_ctx.estAdresseActuelle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex align-items-center mb-5" }, [
                    _createElementVNode("h6", { class: "fw-bold mb-0" }, " Adresse actuelle ")
                  ], -1)),
                  _createElementVNode("span", _hoisted_8, " Agence " + _toDisplayString(_ctx.abonnementData?.bureau?.adresse), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "fw-bold mb-2 ms-2 mt-2 text-white" }, "ABONNE", -1)),
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                        _createElementVNode("h6", { class: "mb-1 ms-2 text-white fss-7" }, "NOMS")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.abonnementData?.abonne?.nomComplet), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                        _createElementVNode("h6", { class: "mb-1 ms-2 text-white fss-7" }, "CATEGORIE")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.abonnementData?.abonne?.categorieAbonne?.libelle), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                        _createElementVNode("h6", { class: "mb-1 ms-2 text-white fss-7" }, "TELEPHONE")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.abonnementData?.numero), 1)
                      ])
                    ])
                  ])
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1))
              ])
            ])
          ])
        ])
      ]),
      (_ctx.estAbonnementPhysique)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[11] || (_cache[11] = _createElementVNode("h5", { class: "fw-bold mb-2 ms-2 mt-0 text-white" }, "BP PHYSIQUE", -1)),
                    _createElementVNode("table", _hoisted_24, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[8] || (_cache[8] = _createElementVNode("td", null, [
                            _createElementVNode("h6", { class: "mb-1 ms-2 text-white fss-7" }, "ADRESSE")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.abonnementPhysique?.boite?.adressePostale?.adresse_postale), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[9] || (_cache[9] = _createElementVNode("td", null, [
                            _createElementVNode("h6", { class: "mb-1 ms-2 text-white fss-7" }, "AGENCE")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.abonnementPhysique?.bureau?.adresse), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("td", null, [
                            _createElementVNode("h6", { class: "mb-1 ms-2 text-white fss-7" }, "ETAT")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.abonnementPhysique?.etat), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.estAbonnementMpostBox)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "fw-bold mb-2 ms-2 mt-2 text-white" }, "BP MPOSTBOX", -1)),
                    _createElementVNode("table", _hoisted_33, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[12] || (_cache[12] = _createElementVNode("td", null, [
                            _createElementVNode("h6", { class: "mb-1 ms-2 text-white fss-7" }, "ADRESSE")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_34, _toDisplayString((_ctx.abonnementVirtuelle?.adresseVirtuelle) ?
                                                _ctx.abonnementVirtuelle?.adresseVirtuelle : ""), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[13] || (_cache[13] = _createElementVNode("td", null, [
                            _createElementVNode("h6", { class: "mb-1 ms-2 text-white fss-7" }, "AGENCE")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.abonnementVirtuelle?.bureau?.adresse), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[14] || (_cache[14] = _createElementVNode("td", null, [
                            _createElementVNode("h6", { class: "mb-1 ms-2 text-white fss-7" }, "ETAT")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.abonnementVirtuelle?.etat), 1)
                          ])
                        ])
                      ])
                    ]),
                    _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mb-15 mb-md-20 mb-xxxl-25 d-flex align-items-center justify-content-between" }, [
            _createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Historique")
          ], -1)),
          _createElementVNode("ul", _hoisted_39, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historique, (el, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "position-relative fw-medium text-dark-emphasis"
              }, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "icon position-absolute start-0 rounded-circle text-center" }, [
                  _createElementVNode("i", { class: "ph-duotone ph-check-circle" })
                ], -1)),
                _createElementVNode("span", _hoisted_40, _toDisplayString(el.titre), 1),
                _createElementVNode("p", _hoisted_41, _toDisplayString(el.description), 1),
                _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.format_date(el.dateOperation)), 1)
              ]))
            }), 128))
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "position-relative mt-20" }, null, -1))
        ])
      ])
    ], 512), [
      [_vShow, _ctx.datatrue]
    ])
  ], 64))
}